import { h, Host } from "@stencil/core";
import { throttle } from "../../utils/throttle";
export class InfiniteScrollSensor {
    constructor() {
        this.hasFired = false;
        this.name = "";
    }
    sensor;
    /** is called when it is scrolled into view */
    scrolledIntoView;
    onScroll = throttle(() => {
        if (!this.hasFired && this.sensor !== null && isInView(this.sensor)) {
            this.hasFired = true;
            this.scrolledIntoView.emit(this.name);
        }
    }, 100);
    connectedCallback() {
        document.addEventListener("scroll", this.onScroll, true);
    }
    disconnectedCallback() {
        document.removeEventListener("scroll", this.onScroll);
    }
    render() {
        return h(Host, { key: 'e9568cf693b174bfa452d4ceae3217ac22646548', class: "ux-infinite-scroll-sensor" });
    }
    static get is() { return "ux-infinite-scroll-sensor"; }
    static get properties() {
        return {
            "hasFired": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "is true after the event was fired. This prevents the event from firing again. set this to false to re-enable the event"
                },
                "attribute": "has-fired",
                "reflect": true,
                "defaultValue": "false"
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "this name will also be in the event"
                },
                "attribute": "name",
                "reflect": true,
                "defaultValue": "\"\""
            }
        };
    }
    static get events() {
        return [{
                "method": "scrolledIntoView",
                "name": "uxInfiniteScrollSensorScrolledIntoView",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "is called when it is scrolled into view"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "sensor"; }
}
function isInView(el) {
    const box = el.getBoundingClientRect();
    return box.top < window.innerHeight && box.bottom >= 0;
}
//# sourceMappingURL=infinite-scroll-sensor.js.map
